import { Children as ReactChildren, type PropsWithChildren, type ReactNode } from "react"
import { Container, Stack, StackItem } from "@octopus-energy/coral/atoms"
import { useCoralBreakpoints } from "@octopus-energy/coral/hooks"
import { type Prettify } from "@oefr/utils/types"
import { type SystemProperties } from "styled-system/types"

export type AsideIllustrationProps = Prettify<
    PropsWithChildren<{
        image: ReactNode
        storyblok?: boolean
        reverse?: boolean
        width?: SystemProperties["width"]
        shiftImage?: boolean
    }>
>

export function AsideIllustration({
    children,
    image,
    width = "33%",
    reverse = false,
    shiftImage = false,
}: AsideIllustrationProps) {
    const { isMaxMd } = useCoralBreakpoints()

    return (
        <Stack
            flexDirection={{ base: "column", md: reverse ? "row-reverse" : "row" }}
            alignItems="center"
            gap="lg"
            fullWidth
        >
            <StackItem
                flex={{ base: "1 0 auto", md: `1 0 ${width}` }}
                order={{ base: shiftImage ? 2 : 1, md: 1 }}
            >
                <Container
                    maxWidth={{ base: "250px", md: "none" }}
                    marginX="auto"
                >
                    <Stack>{image}</Stack>
                </Container>
            </StackItem>

            {isMaxMd ? (
                ReactChildren.map(children, (child, index) => (
                    <StackItem order={index + 1}>{child}</StackItem>
                ))
            ) : (
                <StackItem order="2">{children}</StackItem>
            )}
        </Stack>
    )
}
